import type { TableColumn } from 'liyu-pc-base/typing';
import type { Record, SearchConfig } from 'liyu-pc-base/components/remotePages/typing';
import { btn_list, head_btn_list } from './permission-role-config';
import { event_obj } from 'liyu-pc-base/init-plugin';

export default () => {
  const titleList = {
    title: '权限管理',
    addModalTitle: '新建角色',
    updateTitle: '修改',
    is_create: 'permission/create_role', // userStore.CHECK_AUTH(CREATE_ROLE), // 是否有【新建】按钮
    is_update: 'permission/update_role', // userStore.CHECK_AUTH(UPDATE_ROLE), // 是否有【修改】按钮
    is_remove: 'permission/delete_role', // userStore.CHECK_AUTH(DELETE_ROLE), // 是否有【删除】按钮
    is_recover: 'permission/recover_role', // userStore.CHECK_AUTH(RECOVER_ROLE), // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      role_id: 'id',
    },
    delete: {
      role_id: 'id',
    },
    recover: {
      role_id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      role_id: 'id',
    },
  };

  return {
    addData: '/permission/create_role',
    updateData: '/permission/update_role',
    removeData: '/permission/delete_role',
    recoverData: '/permission/recover_role',
    titleList,
    api_fields,
    btn_list,
    head_btn_list,
    event_obj: event_obj(),
    queryConditionGroupData: null,
    is_selection: true,
    is_operation: [false, false, true, true],
  };
};
